<template>
  <footer v-if="footerData">
    <div class="w flex f-directory">
      <div class="w-1/4 text-center clearfix relative">
        <div class="qr_code">
          <img :src="footerData.qrcode_url" alt="二维码" />
        </div>
        <div class="scan float-left text-left cursor-default">
          扫扫加入<br />小程序
        </div>
        <img
          class="weixin-icon absolute"
          src="../../../static/images/public/WeChat.png"
          alt="微信"
        />
      </div>
      <div class="leading-loose f-tel-address">
        <div>
          <img src="../../../static/images/footer/tel.png" alt="" />
          {{ footerData.information.telephone }}
        </div>
        <div>
          <img src="../../../static/images/footer/address.png" alt="" />
          {{ footerData.information.address }}
        </div>
        <div
          class="friendly-link cursor-pointer"
          @click="
            link({
              type: 'link',
              link: '/link',
              category: 'link'
            })
          "
        >
          <img src="../../../static/images/footer/link.png" alt="" />&nbsp;
          友情链接
        </div>
      </div>
      <div class="w-1/3 p-lr-12">
        <ul class="list-reset leading-loose">
          <!-- <li
            v-for="(item, key) of footerData.information.copyright"
            :key="'copyright_' + key"
          >
            {{ item }}
          </li> -->
          <li>{{ footerData.information.copyright }}</li>
          <li>网站标识码：{{ footerData.information.websitIdCode }}</li>
          <li>公安备案编号：{{ footerData.information.policeNumber }}</li>
          <li>{{ footerData.information.business_license }}</li>
          <li>{{ footerData.information.technical_support }}</li>
          <li>
            <span id="cnzz_stat_icon_1277860647" style="display:block;"
              ><a
                :href="
                  `${
                    'https:' == protocol ? 'https://' : 'http://'
                  }www.cnzz.com/stat/website.php?web_id=1277860647`
                "
                target="_blank"
                title="站长统计"
                ><img
                  border="0"
                  hspace="0"
                  vspace="0"
                  src="http://icon.cnzz.com/img/pic.gif"/></a
            ></span>
          </li>
        </ul>
      </div>
      <div class="text-left">
        <div
          class="gov cursor-pointer"
          @click="windowOpen(footerData.information.gov_link)"
        >
          <img :src="footerData.gov_url" alt="政府找错网站" />
        </div>
        <div
          class="institution cursor-pointer"
          @click="windowOpen(footerData.information.institution_link)"
        >
          <img :src="footerData.institution_url" alt="事业单位" />
        </div>
      </div>
    </div>

    <!-- <div class="w-1/2">
      <div class="inline-block">
        {{ footerData.information.copyright.copyright }}
      </div>
      <div class="w-30"></div>
      <div class="inline-block">
        {{ footerData.information.copyright.business_license }}
      </div>
    </div>
    <div class="w-1/2 text-right">
      技术支持：{{ footerData.information.copyright.technical_support }}
    </div> -->
  </footer>
</template>

<script>
import link from '@/core/mixins/link'
export default {
  name: 'footer-nav',
  mixins: [link],
  data() {
    return {}
  },
  computed: {
    footerData() {
      let data = this.$store.getters['HomeStore/footer']
      return data
    },
    protocol() {
      return document.location.protocol
    }
  },
  methods: {
    windowOpen(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
footer {
  // background-image: url('./images/bg.jpg');
  // background-image: url('../../../static/images/public/decorative-pattern.png');
  background-color: $c-black;
  // background-repeat: repeat;
  width: 100%;
  height: auto; /* footer的高度一定要是固定值*/
  font-family: $f-footer-main;
  font-size: 14px;
  color: $c-white;
  .p-lr-12 {
    padding: 0 10px;
  }
}
.f-directory {
  padding-top: 20px;
  padding-bottom: 26px;
}
.qr_code {
  float: left;
  width: 114px;
  height: 114px;
  background-color: $c-white;
  margin-right: 28px;
  margin-left: 0px;
  vertical-align: super;
  img {
    width: 100%;
    height: 100%;
  }
}
.scan {
  line-height: 23px;
  color: $c-e1e1e1;
  margin-top: 18px;
}
.weixin-icon {
  top: 70px;
  left: 143px;
}

.f-tel-address {
  width: 40%;
  vertical-align: middle;
  line-height: 1;
  border-left: 1px dashed $c-white;
  border-right: 1px dashed $c-white;
  padding-left: 78px;
  cursor: default;
  > div {
    margin-bottom: 20px;
    img {
      margin-right: 10px;
      margin-bottom: 3px;
    }
  }
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
}
select::-ms-expand {
  display: none;
}
.friendly-link {
  position: relative;
  > div {
    color: $c-9c9c9c;
    // padding: 0 10px;
    width: 238px;
    line-height: 30px;
    // border-radius: 0;
    // border: 1.2px solid $c-9c9c9c;
    background-color: $c-transparent;
    // background-image: url('../../../static/images/public/up-gray.png');
    // background-repeat: no-repeat;
    // background-position: 96% 50%;
    // &:hover {
    //   box-shadow: 0 0 5px $c-9c9c9c;
    // }
  }
}
.gov,
.institution {
  margin: 2px 0 16px;
}
.gov img {
  width: 86px;
  height: 40px;
}
.institution img {
  width: 40px;
  height: 50px;
}

.iconfont {
  font-size: 20px;
}
.list-reset {
  li {
    cursor: default;
    line-height: 1;
    padding-bottom: 15px;
    padding-left: 15px;
  }
}
@media only screen and (min-width: 736px) {
}
@media only screen and (max-width: 735px) {
  footer {
    display: none;
  }
}
</style>
